import React, { Component } from "react";
//
import Screen from "./ConnectedScreen";
import CityButton from "../components/CityButton";
import PremiumAlert from "./PremiumAlert";

class VerifyScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      method: null,
    };
  }

  setMethod(val) {
    this.setState({ method: val });

    const { isVerified, setOtpType } = this.props;

    if (val === "sms" || (val === "email" && isVerified)) {
      setOtpType(val);
    }
  }

  render() {
    const { user, isVerified, goTo } = this.props;
    const { method } = this.state;

    const showAlert = method === "email" && !isVerified;

    return (
      <Screen onBack={false} title="Verify your booking" isActive>
        <CityButton name="By Phone" onClick={(ev) => this.setMethod("sms")} />
        <CityButton
          disabled={showAlert}
          name="By Email"
          onClick={(ev) => this.setMethod("email")}
        />
        <br />
        {showAlert && (
          <PremiumAlert
            {...{
              className: "u-mt",
              goTo,
              text:
                "Booking verification by email is only available to _Premium members_.",
            }}
          />
        )}
      </Screen>
    );
  }
}

// @connect
import { connect } from "react-redux";
import { setOtpTypeAction } from "../modules/booking/actions";

function mapState(state) {
  const { auth } = state;

  return {
    user: auth.user,
    isVerified: auth.verified,
  };
}

function mapDispatch(dispatch) {
  return {
    setOtpType(val) {
      dispatch(setOtpTypeAction(val));
    },
  };
}

export default connect(
  mapState,
  mapDispatch
)(VerifyScreen);
